"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectWorkshop = void 0;
const Tags_1 = require("../../Tags");
const CardName_1 = require("../../../CardName");
const CardType_1 = require("../../CardType");
const LogHelper_1 = require("../../../LogHelper");
const SelectCard_1 = require("../../../inputs/SelectCard");
const OrOptions_1 = require("../../../inputs/OrOptions");
const SelectOption_1 = require("../../../inputs/SelectOption");
const CardRenderer_1 = require("../../render/CardRenderer");
const Size_1 = require("../../render/Size");
const CardRenderItem_1 = require("../../render/CardRenderItem");
const Card_1 = require("../../Card");
const constants_1 = require("../../../constants");
const PartyHooks_1 = require("../../../turmoil/parties/PartyHooks");
const PartyName_1 = require("../../../turmoil/parties/PartyName");
const Resources_1 = require("../../../Resources");
class ProjectWorkshop extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.CORPORATION,
            name: CardName_1.CardName.PROJECT_WORKSHOP,
            tags: [Tags_1.Tags.EARTH],
            initialActionText: 'Draw a blue card',
            startingMegaCredits: 34,
            metadata: {
                cardNumber: 'R45',
                description: 'You start with 34 M€, 1 steel and 1 titanium. As your first action, draw a blue card.',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.megacredits(34).steel(1).titanium(1).cards(1).secondaryTag(CardRenderItem_1.AltSecondaryTag.BLUE);
                    b.corpBox('action', (cb) => {
                        cb.vSpace(Size_1.Size.LARGE);
                        cb.action(undefined, (eb) => {
                            eb.text('flip', Size_1.Size.SMALL, true).cards(1).secondaryTag(CardRenderItem_1.AltSecondaryTag.BLUE);
                            eb.startAction.text('?', Size_1.Size.MEDIUM, true).tr(1, Size_1.Size.SMALL);
                            eb.cards(2).digit;
                        });
                        cb.vSpace(Size_1.Size.SMALL);
                        cb.action('Flip and discard a played blue card to convert any VP on it into TR and draw 2 cards, or spend 5 M€ to draw a blue card.', (eb) => {
                            eb.or().megacredits(5).startAction.cards(1).secondaryTag(CardRenderItem_1.AltSecondaryTag.BLUE);
                        });
                    });
                }),
            },
        });
    }
    play(player) {
        player.addResource(Resources_1.Resources.STEEL, 1);
        player.addResource(Resources_1.Resources.TITANIUM, 1);
        return undefined;
    }
    initialAction(player) {
        player.drawCard(1, { cardType: CardType_1.CardType.ACTIVE });
        return undefined;
    }
    getEligibleCards(player) {
        const cards = player.getCardsByCardType(CardType_1.CardType.ACTIVE);
        if (!PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.REDS))
            return cards;
        return cards.filter((card) => {
            if (card.getVictoryPoints === undefined)
                return true;
            const vp = card.getVictoryPoints(player);
            if (vp <= 0)
                return true;
            return player.canAfford(constants_1.REDS_RULING_POLICY_COST * vp);
        });
    }
    canAct(player) {
        const redsAreRuling = PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.REDS);
        Card_1.Card.setRedsActionWarningText(player, 1, this, redsAreRuling, 'flip and discard a blue card', true);
        if (player.canAfford(5))
            return true;
        return this.getEligibleCards(player).length > 0;
    }
    action(player) {
        const activeCards = this.getEligibleCards(player);
        const flipBlueCard = new SelectOption_1.SelectOption('Flip and discard a played blue card', 'Select', () => {
            if (activeCards.length === 1) {
                this.convertCardPointsToTR(player, activeCards[0]);
                this.discardPlayedCard(player, activeCards[0]);
                player.drawCard(2);
                return undefined;
            }
            return new SelectCard_1.SelectCard('Select active card to discard', 'Discard', activeCards, (foundCards) => {
                this.convertCardPointsToTR(player, foundCards[0]);
                this.discardPlayedCard(player, foundCards[0]);
                player.drawCard(2);
                return undefined;
            });
        });
        const drawBlueCard = new SelectOption_1.SelectOption('Spend 5 M€ to draw a blue card', 'Draw card', () => {
            player.payMegacreditsDeferred(5, 'Select how to pay for Project Workshop action.', () => player.drawCard(1, { cardType: CardType_1.CardType.ACTIVE }));
            return undefined;
        });
        if (activeCards.length === 0)
            return drawBlueCard.cb();
        if (!player.canAfford(5))
            return flipBlueCard.cb();
        return new OrOptions_1.OrOptions(drawBlueCard, flipBlueCard);
    }
    convertCardPointsToTR(player, card) {
        if (card.getVictoryPoints !== undefined) {
            const steps = card.getVictoryPoints(player);
            if (steps > 0) {
                player.increaseTerraformRatingSteps(steps);
            }
            else if (steps < 0) {
                const stepsToDecrease = Math.abs(steps);
                player.decreaseTerraformRatingSteps(stepsToDecrease);
            }
            if (card.resourceCount !== undefined)
                card.resourceCount = 0;
            LogHelper_1.LogHelper.logTRChange(player, steps);
        }
    }
    discardPlayedCard(player, card) {
        const cardIndex = player.playedCards.findIndex((c) => c.name === card.name);
        player.playedCards.splice(cardIndex, 1);
        player.game.dealer.discard(card);
        if (card.onDiscard) {
            card.onDiscard(player);
        }
        player.game.log('${0} flipped and discarded ${1}', (b) => b.player(player).card(card));
    }
}
exports.ProjectWorkshop = ProjectWorkshop;
//# sourceMappingURL=ProjectWorkshop.js.map